import { useEffect, useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem("cookieConsent", value);
    setVisible(false);
  };

  const openPolicy = () => {
    const fileName = "/תקנון-שימוש-באתר-ניקיון ואחזקות sg1.pdf";
    window.open(fileName, "_blank");
  };

  if (!visible) return null;

  return (
    <>
      <style>
        {`
          @keyframes slideUp {
            from { transform: translateY(100%); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }

          .cookie-sheet {
            animation: slideUp 0.45s ease-out;
          }

          @media (max-width: 768px) {
            .cookie-actions {
              flex-direction: column;
            }

            .cookie-btn {
              width: 100%;
            }
          }
        `}
      </style>

      <div style={styles.wrapper}>
        <div style={styles.card} className="cookie-sheet">

          <div style={styles.handle} />

          <div style={styles.content}>
            <h3 style={styles.title}>שימוש בעוגיות (Cookies)</h3>

            <p style={styles.text}>
              אתר זה עושה שימוש בקובצי Cookies וטכנולוגיות מעקב דומות לצורך הפעלה תקינה,
              שיפור ביצועים, ניתוח שימושים והתאמת חוויית המשתמש.
              המשך השימוש באתר מהווה הסכמה לכך.
            </p>

            <button onClick={openPolicy} style={styles.link}>
              למדיניות הפרטיות המלאה
            </button>
          </div>

          <div style={styles.actions} className="cookie-actions">

            <button
              className="cookie-btn"
              onClick={() => handleChoice("accepted")}
              style={{ ...styles.button, ...styles.accept }}
            >
              אישור
            </button>

            <button
              className="cookie-btn"
              onClick={() => handleChoice("declined")}
              style={{ ...styles.button, ...styles.decline }}
            >
              סירוב
            </button>

          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
  },
  card: {
    width: "100%",
    maxWidth: "780px",
    background: "#0f172a",
    color: "#fff",
    borderTopLeftRadius: "18px",
    borderTopRightRadius: "18px",
    padding: "14px 18px 18px",
    boxShadow: "0 -10px 35px rgba(0,0,0,0.35)",
    direction: "rtl",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "12px",
  },
  handle: {
    width: "50px",
    height: "5px",
    background: "rgba(255,255,255,0.25)",
    borderRadius: "999px",
    marginTop: "4px",
  },
  content: {
    maxWidth: "700px",
  },
  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "700",
  },
  text: {
    marginTop: "10px",
    fontSize: "15px",
    color: "#d1d5db",
    lineHeight: "1.7",
  },
  link: {
    marginTop: "10px",
    background: "transparent",
    border: "none",
    color: "#60a5fa",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "underline",
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    width: "100%",
    maxWidth: "500px",
    flexDirection: "row",
  },
  button: {
    flex: 1,
    border: "none",
    borderRadius: "14px",
    padding: "14px 20px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
  },
  accept: {
    background: "linear-gradient(135deg,#3b82f6,#2563eb)",
    color: "#fff",
  },
  decline: {
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.12)",
  },
};